import React from 'react'
import OrdenoLoading from '../OrdenoLoading'

const GlobalLoadingOverlay: React.FC = () => {
  return (
    <OrdenoLoading
      variant="fullscreen"
      withCard={true}
      size="md"
      text="Carregando..."
    />
  )
}

export default GlobalLoadingOverlay
